// extracted by mini-css-extract-plugin
export default {"logo":"loadingScreen_logo__SjtkF","loadingBox":"loadingScreen_loadingBox__7Bp1d","loader":"loadingScreen_loader__twKdG","load":"loadingScreen_load__sFyN2"};